import { Link } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { MiddlewareStack } from 'spraypaint';
import { createToast } from '../components/shared/thumbtack/toasts/FlashToaster';
import { loginPath } from './application/ts_routes';

const expiredSessionMiddleware = new MiddlewareStack();

expiredSessionMiddleware.afterFilters.push((response, json) => {
  if (response.status === 401) {
    createToast({
      key: 'expired-session',
      text: (
        <span>
          Your session has expired. Please <Link href={loginPath()}>log in</Link> again.
        </span>
      ),
      timeout: 0,
      type: 'error',
    });
  }
});

export { expiredSessionMiddleware };
